import { Box, Stack, Button } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

import { sxConfig } from './materialTransport.style';

const MaterialTransportActions = ({ isAdding, selectedIndex, total, handleAddClick, handleNavigate, handleClose }) => {
  return (
    <Box sx={sxConfig.formFooter}>
      <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={{ xs: 1, md: 0 }}>
        <Stack direction="row" spacing={1} sx={{ flex: { xs: 1, md: 'none' } }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={[sxConfig.addButton, { flex: { xs: 1, md: 'none' } }]}
            disabled={isAdding}
            onClick={handleAddClick}
          >
            Kártya
          </Button>

          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1, flex: 2 }}>
            <Button
              variant="contained"
              startIcon={<ArrowBackIosIcon />}
              sx={[sxConfig.footerButton, sxConfig.previousButton, { flex: 1, minWidth: 0 }]}
              disabled={selectedIndex <= 0}
              onClick={() => handleNavigate(-1)}
            >
              Előző
            </Button>

            <Button
              variant="contained"
              endIcon={<ArrowForwardIosIcon />}
              sx={[sxConfig.footerButton, sxConfig.nextButton, { flex: 1, minWidth: 0 }]}
              disabled={selectedIndex < 0 || selectedIndex >= total - 1}
              onClick={() => handleNavigate(1)}
            >
              Következő
            </Button>
          </Box>
        </Stack>

        <Stack direction="row" spacing={{ xs: 1, md: 1.5 }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIosIcon />}
            sx={[sxConfig.footerButton, sxConfig.previousButton, { display: { xs: 'none', md: 'inline-flex' } }]}
            disabled={selectedIndex <= 0}
            onClick={() => handleNavigate(-1)}
          >
            Előző
          </Button>

          <Button
            variant="contained"
            endIcon={<ArrowForwardIosIcon />}
            sx={[sxConfig.footerButton, sxConfig.nextButton, { display: { xs: 'none', md: 'inline-flex' } }]}
            disabled={selectedIndex < 0 || selectedIndex >= total - 1}
            onClick={() => handleNavigate(1)}
          >
            Következő
          </Button>

          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            sx={[sxConfig.footerButton, sxConfig.saveButton, { flex: { xs: 1, md: 'none' } }]}
            type="submit"
          >
            Mentés
          </Button>

          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            sx={[sxConfig.footerButton, sxConfig.closeButton, { flex: { xs: 1, md: 'none' } }]}
            onClick={handleClose}
          >
            Bezár
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default MaterialTransportActions;
